import Store from '../store/store'

export default class Cart {
    constructor() {
        this.cart = [];
        this.account = [];
        this.beats = [];
        this.licenses = [];
        this.discountedCart = false;
        this.coupon = null ;
        this.couponAppliedTo = [];
        this.couponApplied = false;
        this.currency = "USD";
        this.currencyPrefix = "$";
        this.currencyRate = "1";
        this.total = 0;
        this.couponDiscount = 0;
        this.totalPackageDiscount = 0;
        this.requestQueue = [];
        this.requestData = {
            type: 'webstore',
            seller_id: Store.state.user.id,
            // sales_tracking: Store.state.configuration.sales_tracking,
        }
        this.sessionExists = this.checkCartIdCookieExists();
        this.timeOut = null;
        this.discountedLicenseNames = [];
        this.couponItemsUsed = 0;
    }

    get couponMaxItems() {
        return this.coupon?.maxItems || 0;
    }

    getCart () {
        return this.cart;
    }

    getTotal() {
        return this.total;
    }

    addItem (newItem) {
        Store.commit('setUserClickedOnBuy', true)

        if (this.timeOut) {
            clearTimeout(this.timeOut);
        }

        let itemRemovedOrReplaced = this.removeOrReplaceItem(newItem)
        if (itemRemovedOrReplaced == 'removed') {
            return
        }

        if (!itemRemovedOrReplaced) {
            this.cart.push(newItem);
        }

        this.addToRequestQueue(newItem)
        this.total = this.calculateTotal();
        Store.state.eventTracker.addToCart(newItem);
        Store.commit('toggleCartPopupClick', true)

        this.timeOut = setTimeout(() => {
            if (!Store.state.popupIsHovered) {
                Store.commit('toggleCartPopupClick', false)
            }
        }, 5000);
    }

    removeOrReplaceItem(newItem) {
        for (let i = 0; i < this.cart.length; i++) {
            // Loop through the cart to see if the same item exists already
            const existingItem = this.cart[i];
            if (this.newItemMatchesCartItem(newItem, existingItem)) {
                this.removeItem(existingItem);
                return "removed";
            }

            const bothAreBeats = newItem.item.getType() === "beat" && existingItem.item.getType() === "beat";
            const bothAreSoundkits = newItem.item.getType() === "soundkit" && existingItem.item.getType() === "soundkit";
            const sameId = existingItem.item.id === newItem.item.id;
            // Item matches but license does not
            if ((bothAreBeats || bothAreSoundkits) && sameId) {
                Store.state.app.$set(this.cart, i, newItem);
                return "replaced";
            }
        }

        return false;
    }

    removeItem (cartItem) {
        // If there is only one item left in the cart close popup
        if(this.cart.length === 1) {
            Store.commit('toggleCartPopupClick', false)
        }

        for (var i = 0; i < this.cart.length; i++) {
            if (this.newItemMatchesCartItem(cartItem, this.cart[i])) {
                this.cart.splice(i, 1);
                break
            }
        }

        this.ajaxRemoveItemFromCart(cartItem)

        this.total = this.calculateTotal();
    }

    newItemMatchesCartItem(newItem, cartItem) {
        if (newItem.item.getType() == "beat"
            && cartItem.item.getType() == "beat"
            && cartItem.item.id == newItem.item.id
            && cartItem.license.id == newItem.license.id) {

            return true
        }

        if (newItem.item.getType() == "song"
            && cartItem.item.getType() == "song"
            && cartItem.item.id == newItem.item.id) {

            return true
        }

        if (newItem.item.getType() == "collection"
            && cartItem.item.getType() == "collection"
            && cartItem.item.id == newItem.item.id) {

            return true
        }

        if (newItem.item.getType() == "soundkit"
            && cartItem.item.getType() == "soundkit"
            && cartItem.item.id == newItem.item.id
            && cartItem.license.id == newItem.license.id) {

            return true
        }
        if (newItem.item.getType() == "beattapes"
            && (cartItem.item.getType() == "collection" || cartItem.item.getType() == "beattapes")
            && cartItem.item.id == newItem.item.id) {

            return true
        }

        if (newItem.item.getType() == "service"
            && cartItem.item.getType() == "service"
            && cartItem.item.id == newItem.item.id) {

            return true
        }

        if (newItem.item.getType() == "service_quote"
            && cartItem.item.getType() == "service_quote"
            && cartItem.item.id == newItem.item.id) {

            return true
        }


        return false
    }

    empty() {
        this.cart = [];
        this.total = this.calculateTotal();
        this.ajaxEmptyCart()
        Store.commit('toggleCartPopupClick', false)
    }

    setBeats (beats) {
        this.beats = beats;
    }

    resetPrices () {
        this.cart.forEach((cartItem) => {
            cartItem.resetPrice()
        })
    }

    calculateTotal () {
        var total = 0;
        var numberOfItemsToDiscount = [];
        var totalPackageDiscount = 0;
        let totalDiscount = 0

        this.resetPrices()

        if (Store.state.user.isPaid()) {
            let discountableCartItems = this.getDiscountableCartItems();
            if (discountableCartItems.length) {

                this.discountedLicenseNames = [];

                this.discountedLicenseNames = discountableCartItems.map((item) => {
                    var licenseName = item[0].licenseName()

                    if (item.length >= item[0].discountsMinQuantity()) {
                        return
                    }

                    return licenseName

                }).filter((item, index, currentArray) => {
                    return currentArray.find((name) => name == item) != null
                }).filter(item => item)

                for (item in discountableCartItems) {
                    if (discountableCartItems[item].length >= discountableCartItems[item][0].discountsMinQuantity()) {
                        Store.commit('togglePackageDiscountsNotice', false)
                        continue
                    }

                    Store.commit('togglePackageDiscountsNotice', true)
                    break
                }

            } else {
                this.discountedLicenseNames = []
                Store.commit('togglePackageDiscountsNotice', false)
            }

            let discountableItemsPerLicense = this.countDiscountableCartItemsPerLicense(discountableCartItems);
            let discountPrices = {}
            // GO THROUGH LICENSE DISCOUNT OPTIONS TO SEE HOW MANY BEATS SHOULD BE DISCOUNTED
            for (var licenseId in discountableCartItems) {
                let cartItems = discountableCartItems[licenseId];
                let discounts = cartItems[0].license.discounts;

                for (let i = 0; i < discounts.length; i++) {
                    let nextLevel = i + 1;
                    let currentDiscountLevelQuantity = discounts[i].quantity;
                    let nextDiscountLevelQuantity = (discounts[nextLevel]) ? discounts[nextLevel].quantity : null;

                    if (discountableItemsPerLicense[licenseId] >= currentDiscountLevelQuantity &&
                        (!nextDiscountLevelQuantity || discountableItemsPerLicense[licenseId] < nextDiscountLevelQuantity)) {

                        numberOfItemsToDiscount[licenseId] = currentDiscountLevelQuantity;

                        discountPrices[licenseId] = discounts[i].price;

                        break;
                    }
                }
            }

            // DISCOUNT RELEVANT LICENSES AND SET PRICES IN CART
            for (var licenseId in discountableCartItems) {
                if (numberOfItemsToDiscount[licenseId] > 0) {
                    var lstart = 0;

                    for (var i = 0; i < discountableCartItems[licenseId].length; i++) {
                        if (lstart == 0) {
                            let itemPriceBeforeDiscount = discountableCartItems[licenseId][i].item.pricing[licenseId].price
                            discountableCartItems[licenseId][i].setPrice(discountPrices[licenseId] * this.currencyRate);
                            totalPackageDiscount += (itemPriceBeforeDiscount - discountPrices[licenseId]);
                        } else if (lstart > 0 && lstart < numberOfItemsToDiscount[licenseId]) {
                            totalPackageDiscount += discountableCartItems[licenseId][i].item.pricing[licenseId].price
                            discountableCartItems[licenseId][i].setPrice(0);
                        }
                        lstart++;

                    }

                    for (var i = 0; i < discountableCartItems[licenseId].length; i++) {
                        var item = discountableCartItems[licenseId][i];

                        for (var s = 0; s < this.cart.length; s++) {

                            if (this.cart[s].item.id == item.id) {
                                this.cart[s].setPrice(discountPrices[licenseId] * this.currencyRate);
                            }
                        }
                    }
                }
            }

            this.discountedCart = false;

            for (var license_id in numberOfItemsToDiscount) {
                if (numberOfItemsToDiscount[license_id] > 0) {
                    this.discountedCart = true;
                    break
                }
            }
        }

        this.setCartPricingWithCouponDiscount()

        for (var i = 0; i < this.cart.length; i++) {
            total += Number(this.cart[i].price);
        }

        // Calculate Total Discount
        this.cart.forEach((cartItem) => {
            totalDiscount += cartItem.originalPrice - cartItem.price;
        });

        this.totalPackageDiscount = parseFloat(totalPackageDiscount);
        this.couponDiscount = parseFloat(totalDiscount) - this.totalPackageDiscount;

        return total;
    }

    resetCartPrices () {
        for (var i = 0; i < this.cart.length; i++) {
            this.cart[i].resetPrice();
        }
    }

    setCoupon (coupon) {
        this.applyCoupon(coupon)

        let requestData = this.requestData
        requestData.coupon_id = coupon.id

        Store.state.app.$http.post("/cart/coupon", requestData, {
            headers: {
                'X-XSRF-TOKEN': Store.state.xsrfToken
            }
        });
    }

    applyCoupon (coupon) {
        var licenses = coupon.licenses;
        coupon.licenses = [];

        for (var i = 0; i < licenses.length; i++) {
            var license = licenses[i];
            coupon.licenses[license.id] = license;
        }
        this.couponAppliedTo = coupon['applies_to'];
        this.coupon = coupon;
        this.couponApplied = true;

        this.total = this.calculateTotal();
    }

    unsetCoupon () {
        this.removeCoupon()

        Store.state.app.$http.delete("/cart/coupon", {params: this.requestData,
            headers: {
                'X-XSRF-TOKEN': Store.state.xsrfToken
            }
        })
    }

    removeCoupon () {
        this.coupon = false
        this.couponApplied = false
        this.couponAppliedTo = []
        this.total = this.calculateTotal()
    }

    getCoupon () {
        return this.coupon;
    }

    setCartPricingWithCouponDiscount() {
        this.couponItemsUsed = 0;
        const items = [...this.cart]
        // sort items by price descending
        items.sort((a, b) => {
            return b.price - a.price
        });

        items.forEach(({ item, license, price }, i) => {
            const itemType = item.getType();
            let discountedPrice;
            switch (itemType) {
                case "beat":
                    discountedPrice = this.applyCouponDiscount({itemType, price, licenseId: license.id});
                    break;
                case "soundkit":
                    discountedPrice = this.applyCouponDiscount({itemType, price});
                    break;
                default:
                    discountedPrice = this.applyCouponDiscount({itemType, price});
            }
            items[i].price = (discountedPrice * this.currencyRate).toFixed(2);
        });
    }

    applyCouponDiscount ({ itemType, price, licenseId }) {
        // Ignore if no coupon is applied
        if(!this.couponApplied) return price

        // Check eligibility of item for coupon
        const isSoundkitCoupon = itemType === 'soundkit' && this.coupon.applies_to.includes('soundkit')
        const isBeatCoupon = itemType === 'beat' && this.coupon.licenses[licenseId]
        const isSongCoupon = itemType === 'song' && this.coupon.applies_to.includes('song')
        const isServiceCoupon = itemType === 'service' && this.coupon.applies_to.includes('service')
        const isCollectionCoupon = itemType === 'collection' && this.coupon.applies_to.includes('collection')
        const eligibleForCoupon = isSoundkitCoupon || isBeatCoupon || isSongCoupon || isCollectionCoupon || isServiceCoupon

        // Ignore if not eligible for coupon or discount is 0
        if(!eligibleForCoupon
            || this.coupon.discount === 0
            || (this.couponMaxItems && this.couponItemsUsed >= this.couponMaxItems)
        ) {
            return price
        }

        this.couponItemsUsed++

        return price - ((price / 100) * this.coupon.discount);
    }

    formatPrice (price) {
        price = Number(price).toFixed(2);
        price += '';
        var x = price.split('.'),
            x1 = x[0],
            x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ',' + '$2');
        }
        return x1 + x2;
    }

    displayPrice (price, asLabel) {
        return (!asLabel || price !== '0.00') ? this.currencyPrefix + price : 'Free';
    }

    totalForDisplay() {
        return this.displayPrice(this.formatPrice(this.total), true);
    }

    inCart(item, license = null) {
        const itemType = item.getType();

        return this.cart.some(cartItem => {
            const cartItemType = cartItem.item.getType();

            // An item on the page has 'beattapes' as its type, while in the cart it has 'collection' as its type.

            let typeMatch = cartItemType === itemType;
            if ((cartItemType === 'collection' && itemType === 'beattapes') ||
                (cartItemType === 'beattapes' && itemType === 'collection')) {
                typeMatch = true;
            }

            return typeMatch
                && cartItem.item.id == item.id
                && (!license || !cartItem.license || cartItem.license.id == license.id);
        });
    }


    /**
     * Create array with license id as key with all items that are
     * discountable (license allows discount and item  allows discount)
     * @returns {Array}
     */
    getDiscountableCartItems() {
        let cartItems = [];

        for(var i = 0; i < this.cart.length; i++) {
            var cartItem = this.cart[i];

            if (cartItem.item.getType() == "beat") {
                var license = cartItem.license;

                if (cartItem.item.pricing[license.id].hasDiscount()) {

                    if (!cartItems[license.id]) {
                        cartItems[license.id] = [];
                    }

                    cartItems[license.id].push(this.cart[i]);
                }
            }
        }

        return cartItems;
    }

    /**
     * Create array keyed by license id counting number of
     * discountable items per license
     * @param discountableCartItems
     * @returns {Array}
     */
    countDiscountableCartItemsPerLicense(discountableCartItems) {
        let count = [];

        for (var license_id in discountableCartItems) {
            if (count[license_id] == undefined) {
                count[license_id] = 0
            }

            count[license_id] += discountableCartItems[license_id].length
        }

        return count;
    }

    addToRequestQueue(cartItem) {
        this.requestQueue.push(cartItem)

        if (this.requestQueue.length == 1) {
            this.processNextInRequestQueue()
        }
    }

    removeFromRequestQueue(cartItem) {
        for (var i = 0; i < this.requestQueue.length; i++) {
            if (cartItem.type == "beat") {
                if (cartItem.item.id == this.requestQueue[i].item.id &&
                    cartItem.license.id == this.requestQueue[i].license.id) {
                    this.requestQueue.splice(i, 1)
                    break
                }

            } else {
                if (cartItem.item.id == this.requestQueue[i].item.id) {
                    this.requestQueue.splice(i, 1)
                    break
                }
            }
        }

        this.processNextInRequestQueue()
    }

    processNextInRequestQueue() {
        if (this.requestQueue.length > 0) {
            this.ajaxAddItemToCart(this.requestQueue[0])
        }
    }

    ajaxAddItemToCart(cartItem) {

        if (this.sessionExists) {
            let cartRequestData = this.requestData

            cartRequestData.cartable_id = cartItem.item.id
            cartRequestData.cartable_type = cartItem.item.getType()

            if (['soundkit', 'beat'].includes(cartRequestData.cartable_type)) {
                cartRequestData.license_id = cartItem.license.id
            }

            Store.state.app.$http.post('/cart/item', cartRequestData, {
                headers: {
                    'X-XSRF-TOKEN': Store.state.xsrfToken
                }
            }).then(() => {
                this.removeFromRequestQueue(cartItem)
            })

        } else {
            this.removeFromRequestQueue(cartItem)
        }
    }

    ajaxRemoveItemFromCart(cartItem) {

        if (this.sessionExists) {
            let cartRequestData = this.requestData

            cartRequestData.cartable_id = cartItem.item.id
            cartRequestData.cartable_type = cartItem.item.getType()

            if (cartItem.item.isBeat()) {
                cartRequestData.license_id = cartItem.license.id
            }

            Store.state.app.$http.delete('/cart/item', {params: cartRequestData,
                headers: {
                    'X-XSRF-TOKEN': Store.state.xsrfToken
                }
            });
        }
    }

    ajaxEmptyCart() {

        if (this.sessionExists) {
            let data = {
                type: 'webstore',
                seller_id: Store.state.user.id,
                _token: Store.state.csrfToken
            }

            Store.state.app.$http.delete('/cart', { params: data, headers: {
                    'X-XSRF-TOKEN': Store.state.xsrfToken
                }});
        }
    }

    processSavedCart(cartItems) {
        for (var i = 0; i < cartItems.length; i++) {
            this.cart.push(cartItems[i])
        }

        this.total = this.calculateTotal()
    }

    itemsToString()
    {
        var names = [];

        for (var i = 0; i < this.cart.length; i++) {
            names.push(this.cart[i].item.name);
        }

        return names.join(', ');
    }

    base64EncodedCart() {
        var items = [];

        for (var i = 0; i < this.cart.length; i++) {
            var cartItem = this.cart[i];

            var item = {};

            item.i = cartItem.item.id;

            switch (cartItem.type) {
                case 'beat':
                    item.t = 'b';
                    break;
                case 'song':
                    item.t = 's';
                    break;
                case 'collection':
                    item.t = 'c';
                    break;
                case 'soundkit':
                    item.t = 'sk';
                    break;
                case 'beattapes':
                    item.t = 'bt';
                    break;
                case 'service':
                    item.t = 'srv';
                    break;
                case 'service_quote':
                    item.t = 'srvqt';
                    break;
            }

            if (cartItem.license) {
                item.l = cartItem.license.id;
            }

            items.push(item);
        }

        return items.length ? btoa(JSON.stringify(items)) : '';
    }

    checkCartIdCookieExists() {
        var cookies = document.cookie.split(';');

        for (var i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].split('=');
            if ($.trim(cookie[0]) == 'cart_id') {
                return true
            }
        }
        return false;
    }

    isEmpty(){
        return this.cart.length == 0 ? true : false;
    }

    licenseNamesInCart() {
        let licenses = this.discountedLicenseNames
        let licensesString = ''

        licenses.filter((value, index) => licenses.indexOf(value) === index).forEach((val) => {
            licensesString += `, ${val}`
        })

        return licensesString.substr(1)
    }

    getSummary () {
        return {
            total: this.getTotal(),
            coupon: this.couponApplied ? this.coupon?.code : '',
            items: this.getCart().map(this.getItemSummary)
        }
    }

    getItemSummary(cartItem) {
        const total = parseFloat(cartItem.price)
        const type = cartItem.type

        return  {
            id: cartItem.item.id,
            name: cartItem.item.name,
            type,
            license: cartItem.licenseName(),
            price: cartItem.originalPrice,
            discount: cartItem.discountedAmount,
            total,
        }
    }
}
